export enum VatReportType {
  MONTHLY = "Месячный",
  QUARTERLY = "Квартальный",
  YEARLY = "Годовой",
}

export interface IVatReport {
  _id: string;
  reportNumber: string;
  reportType: VatReportType;
  period: {
    startDate: string;
    endDate: string;
  };
  totalSales: {
    amountWithoutVat: { USD: number; TJS: number };
    vatAmount: { USD: number; TJS: number };
    totalAmount: { USD: number; TJS: number };
  };
  totalPurchases: {
    amountWithoutVat: { USD: number; TJS: number };
    vatAmount: { USD: number; TJS: number };
    totalAmount: { USD: number; TJS: number };
  };
  vatLiability: { USD: number; TJS: number };
  vatCredit: { USD: number; TJS: number };
  netVatLiability: { USD: number; TJS: number };
  exchangeRate: number;
  notes?: string;
  isSubmitted: boolean;
  submittedDate?: string;
  createdAt: string;
  updatedAt: string;
} 